var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionThemedEvent } from "./actionThemedEvent";
var initial = {
    difficulty: undefined,
    eventId: undefined,
    quest: undefined,
};
export var reducerThemedEvent = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionThemedEvent.StartResponse:
            return __assign({}, state, { difficulty: action.difficulty, eventId: action.eventId, quest: action.quest });
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/reducerThemedEvent.ts
// module id = 2979
// module chunks = 3